import { toCodePointChar } from "#to-code-point-char";

/**
 * Matches a lone code point in the CJK Strokes block (U+31C0–U+31EF).
 *
 * V8 does not expose Unicode `Block=` property escapes, so this uses a code-point range class.
 */
export const CJK_STROKE_REGEX = /^[\u{31C0}-\u{31EF}]$/u;

/**
 * True if the first code point is in the CJK Strokes block (U+31C0–U+31EF).
 *
 * V8 does not expose Unicode `Block=` property escapes, so this uses a code-point range class.
 */
export function isCjkStroke(value: string | number): boolean {
  return CJK_STROKE_REGEX.test(toCodePointChar(value));
}
